{
	"ordersInfo": {
		"ticker": "Ticker",
		"option": "Option",
		"tickerCompany": "Ticker/Company",
		"operation": "Operation",
		"quantity": "Quantity",
		"sum": "Sum",
		"profitability": "Profitability",
		"dateTime": "Date/Time",
		"actions": "Actions",
		"price": "Price",
		"openedOrders": "Opened Orders",
		"statusTitle": "Status",
		"term": "Term",
		"orderStatus": "Order Status",
		"orderStatusPlaceholder": "Select Order Status",
		"orderType": "Order Type",
		"executed": "Executed",
		"averagePrice": "Average Price",
		"averageExecutedPrice": "Average Executed Price",
		"orderDuration": "Order Duration",
		"profitabilityInPercent": "Profitability (%)",
		"brokerCommission": "Broker Commission",
		"placed": "Placed Date",
		"updated": "Updated Date",
		"filled": "Filled Date",
		"canceled": "Canceled Date",
		"close": "Close",
		"stopPrice": "Stop Price",
		"limitPrice": "Limit Price",
		"trailPrice": "Trail Price",
		"trailPercent": "Trail Percent",
		"stopLoss": "Stop Loss",
		"takeProfit": "Take Profit",
		"pcs": "pcs",
		"orderId": "ID",
		"side": {
			"buy": "Buy",
			"sell": "Sell",
			"sell_short": "Sell Short"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		}
	}
}
